export * from './nextcloud-delete-template';
